import { format } from 'date-fns';
import { ISortBy } from '../Models/sortby.model';
import config from '../config';

export const getUrl = (): string => {
  //   // Determine the environment and load the appropriate .env file
  console.log('api url', config.TRAVELHEARTS_API_URL);
  return config.TRAVELHEARTS_API_URL || 'http://127.0.0.1:8080/api/v1/';
  // return 'http://www.travelheartstesting.com/api/v1/';
};

export const getAppImagesUrl = (): string => {
  return config.TRAVELHEARTS_IMAGES_URL || '';
};

export const chunkArray = (array: any[], chunkSize: number) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, 'MM/dd/yyyy');
};

export function debounce(func: (...args: any[]) => void, wait: number) {
  let timeout: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

const sortArrayOnStrings = <T extends { [key: string]: any }>(
  array: T[],
  sortBy: ISortBy
): T[] => {
  return array.sort((a, b) => {
    if (a[sortBy.field] < b[sortBy.field]) {
      return sortBy.direction === 'asc' ? -1 : 1;
    }
    if (a[sortBy.field] > b[sortBy.field]) {
      return sortBy.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
};

const sortArrayOnDates = <T extends { [key: string]: any }>(
  array: T[],
  sortBy: ISortBy
): T[] => {
  return array.sort((a, b) => {
    const fieldA = new Date(a[sortBy.field]);
    const fieldB = new Date(b[sortBy.field]);

    if (fieldA < fieldB) {
      return sortBy.direction === 'asc' ? -1 : 1;
    }
    if (fieldA > fieldB) {
      return sortBy.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
};

export const sortArray = <T extends { [key: string]: any }>(
  array: T[],
  sortBy: ISortBy
): T[] => {
  if (array.length <= 1) {
    return array;
  }

  if (array[0][sortBy.field] instanceof Date) {
    return sortArrayOnDates(array, sortBy);
  }
  return sortArrayOnStrings(array, sortBy);
};
